import { Button } from 'antd';

export function SaveButton({ handleSubmit }) {
  return (
    <Button style={{ width: 180, height: 40 }} onClick={handleSubmit} type="primary">
      Uložiť
    </Button>
  );
}
